export default __webpack_public_path__ + "static/media/complementos_5.f19ac4b7.jpg";